import { ReactElement } from 'react';

import { Directions } from '@cashier/cashier-model';
import { cn } from '@cashier/cashier-ui';

import styles from './styles.module.scss';

interface UrlRowProps {
  label: string;
  linkUrl: string;
  direction: Directions;
}

export const UrlRow = ({
  label,
  linkUrl,
  direction,
}: UrlRowProps): ReactElement => {
  if (direction === Directions.Ltr) {
    return (
      <div className={styles.container}>
        <div
          className={cn([styles.text, styles.leftColumn])}
          data-test="left-column"
        >
          {label}
        </div>
        <div
          className={cn([styles.text, styles.rightColumn])}
          data-test="right-column"
        >
          <a
            className={styles.link}
            href={linkUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {linkUrl}
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div
        className={cn([styles.text, styles.leftColumn])}
        data-test="left-column"
      >
        <a
          className={styles.link}
          href={linkUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {linkUrl}
        </a>
      </div>
      <div
        className={cn([styles.text, styles.rightColumn])}
        data-test="right-column"
      >
        {label}
      </div>
    </div>
  );
};
